import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { breadcrumbs } from "../siteData";

const origin = "https://primepathmotors.com";

/**
 * Breadcrumb trail for every page below Home.
 *
 * The trail is the way back. Privacy and Terms in particular used to be
 * reachable from the footer with no route out except the browser button.
 *
 * The last crumb is the current page and is not a link: it is marked
 * aria-current="page" so a screen reader announces where it stops.
 */
export default function Breadcrumbs({ path, trail }) {
  const items = trail || breadcrumbs[path];
  if (!items || !items.length) return null;

  const full = [["Home", "/"], ...items];

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: full.map(([name, to], i) => ({
            "@type": "ListItem",
            position: i + 1,
            name,
            item: `${origin}${to === "/" ? "" : to}`,
          })),
        })}</script>
      </Helmet>
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <ol>
          {full.map(([name, to], i) => {
            const last = i === full.length - 1;
            return (
              <li key={to}>
                {last
                  ? <span aria-current="page">{name}</span>
                  : <Link to={to}>{name}</Link>}
                {last ? null : <span className="crumb-sep" aria-hidden="true">/</span>}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}
